import { useEffect } from 'react';
import { useData } from '../../context/DataContext';
import { useToast } from '../../context/ToastContext';

export function useCriticalStockAlert() {
  const { stockItems } = useData();
  const { showToast, notifications, clearNotificationsByRelated } = useToast();

  useEffect(() => {
    const criticalIds = new Set(stockItems.filter(s => s.critical).map(s => s.id));

    stockItems.forEach(s => {
      if (!s.critical) return;
      const alreadyNotified = notifications.some(n => n.relatedType === 'stockItem' && n.relatedId === String(s.id));
      if (!alreadyNotified) {
        showToast(`⚠️ ${s.name} kritik stok seviyesinde!`, 'error', { id: String(s.id), type: 'stockItem' });
      }
    });

    // Artık kritik olmayan kalemlerin bildirimini temizle
    notifications.forEach(n => {
      if (n.relatedType === 'stockItem' && n.relatedId && !criticalIds.has(Number(n.relatedId))) {
        clearNotificationsByRelated('stockItem', n.relatedId);
      }
    });
  }, [stockItems, notifications, showToast, clearNotificationsByRelated]);
}
